// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import entityReducer from './generators/entityReducer'
import * as types from '../actions/action-types'
import * as entityTypes from './generators/entities'

export default entityReducer(
  'globalShiftBookings',
  {
    [entityTypes.ENTITIES_FETCH_BEGIN]: types.GLOBAL_SHIFT_BOOKINGS_BEGIN,
    [entityTypes.ENTITIES_FETCH_SUCCEEDED]: types.GLOBAL_SHIFT_BOOKINGS_SUCCEEDED,
    [entityTypes.ENTITIES_FETCH_FAILED]: types.GLOBAL_SHIFT_BOOKINGS_FAILED,
  },
  {
    // When we reach over 250 cached items in the store,
    // reduce the number of items to the 125 latest.
    itemLimit: [250, 125],
  }
)
